import React, { useState } from 'react'
import PropTypes from 'prop-types'
import NormalIcon from '../../../../../Assets/icons/icono-normal.svg'
import UrgentIcon from '../../../../../Assets/icons/icono-urgente.svg'
import { EMPTY } from '../../../../../graphql/Auth/auth'
import { useMutation } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'

const PriorityBox = ({
  id,
  priority,
  updatePriority,
  mutationUpdate = EMPTY,
  refetchMain,
  normalStyle = {
    color: '#00BCD4',
    border: '3px solid #00BCD4',
    padding: '3px 0px',
    borderRadius: '15px',
    width: '1vw',
    minWidth: '7vw',
    maxWidth: '7vw',
    fontWeight: 'bold',
    marginRight: '100px',
  },
  urgentStyle = {
    color: '#FF4D4D',
    border: '3px solid #FF4D4D',
    padding: '3px 0px',
    borderRadius: '15px',
    width: '7vw',
    minWidth: '7vw',
    maxWidth: '7vw',
    fontWeight: 'bold',
    marginRight: '100px',
  },
  specialStyle = {
    color: '#FF4D4D',
    border: '3px solidrgb(255, 213, 77)',
    padding: '3px 0px',
    borderRadius: '15px',
    width: '7vw',
    minWidth: '7vw',
    maxWidth: '7vw',
    fontWeight: 'bold',
    marginRight: '100px',
  },
  showImage = true,
  showImageMenu = true,
}) => {
  const { hideLoading, showLoading } = useLoading()
  const [priorityMutation] = useMutation(mutationUpdate)

  const getPriorityStyle = () => {
    switch (priority) {
      case 'normal':
        return normalStyle
      case 'urgente':
        return urgentStyle
      case 'especial':
        return specialStyle
      default:
        return {}
    }
  }

  const handleSelect = async (selectedPriority) => {
    try {
      const capitalizedPriority =
        priority.charAt(0).toUpperCase() + priority.slice(1)
      const capitalizedSelectedPriority =
        selectedPriority.charAt(0).toUpperCase() + selectedPriority.slice(1)
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        icon: 'info',
        title: '¿Estás seguro de cambiar la prioridad?',
        message: `Esta seguro de cambiar la prioridad de ${capitalizedPriority} a ${capitalizedSelectedPriority}`,
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data } = await priorityMutation({
        variables: {
          id: +id,
          priority: selectedPriority,
        },
      })

      if (data) {
        await refetchMain()
        return toastSweetAlert({
          mode: 'ok',
          message: `Prioridad actualizada a ${selectedPriority}`,
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <div
      className={`d-flex justify-content-center ${
        updatePriority && 'priority-dropdown'
      }`}
      style={getPriorityStyle()}
    >
      {updatePriority ? (
        <span
          className="dropdown-toggle"
          type="button"
          id="priorityDropdown"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          {showImage && (
            <img
              src={priority === 'normal' ? NormalIcon : UrgentIcon}
              alt="Priority"
              style={{ width: '1vw', marginRight: '6px' }}
            />
          )}
          {priority === 'normal' ? 'Normal' : 'Urgente'}
        </span>
      ) : (
        <>
          {showImage && (
            <img
              src={priority === 'normal' ? NormalIcon : UrgentIcon}
              alt="Priority"
              style={{ width: '1vw', marginRight: '6px' }}
            />
          )}
          {priority === 'normal'
            ? 'Normal'
            : priority === 'urgente'
            ? 'Urgente'
            : 'Especial'}
        </>
      )}

      {updatePriority && (
        <ul className="dropdown-menu" aria-labelledby="priorityDropdown">
          <li>
            <button
              className={`dropdown-item d-flex align-items-center ${
                priority === 'normal' && 'selected'
              }`}
              onClick={() => handleSelect('normal')}
              disabled={priority === 'normal'}
            >
              {showImageMenu && (
                <img
                  src={NormalIcon}
                  alt="Normal"
                  style={{ width: 16, marginRight: 8 }}
                />
              )}
              Normal
            </button>
          </li>
          <li>
            <button
              className={`dropdown-item d-flex align-items-center ${
                priority === 'urgente' && 'selected'
              }`}
              onClick={() => handleSelect('urgente')}
              disabled={priority === 'urgente'}
            >
              {showImageMenu && (
                <img
                  src={UrgentIcon}
                  alt="Urgente"
                  style={{ width: 16, marginRight: 8 }}
                />
              )}
              Urgente
            </button>
          </li>
        </ul>
      )}
    </div>
  )
}

PriorityBox.propTypes = {
  priority: PropTypes.oneOf(['normal', 'urgente', 'special']).isRequired,
}

export default PriorityBox
